import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
          精选品类
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          三大核心品类，每一件欧美精品均经严格品控，品质有保障
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to="/categories"
            className="group relative overflow-hidden rounded-lg h-[320px] md:h-[360px] cursor-pointer"
          >
            <div className="absolute inset-0 w-full h-full">
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="font-heading text-lg md:text-xl font-semibold text-white mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-white/75 leading-relaxed">
                {cat.description}
              </p>
              <span className="inline-block mt-3 text-xs text-white/90 font-medium border-b border-white/40 pb-0.5 group-hover:border-white/80 transition-colors">
                探索更多 →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}